import CourseCard from './CourseCard';
import CourseStatus from '../models/CourseStatus';
import Grid from '@mui/material/Unstable_Grid2';
import Pathway from '../models/Pathway';
import React from 'react';
import { useInView } from 'react-intersection-observer';

interface ICoursesProps {
  pathways: Pathway[];
  statusLoad: (pathkey: string, status: CourseStatus) => void;
}

const CourseItem = (props: ICoursesItemProps) => {
  const { ref, inView } = useInView({
    threshold: 0.1 // Trigger when 10% of the component is visible
  });

  return (
    <Grid ref={ref}>
      <CourseCard
        pathway={props.pathway}
        isVisible={inView}
        onStatusLoad={props.statusLoad}
      />
    </Grid>
  );
};

interface ICoursesItemProps {
  pathway: Pathway;
  statusLoad: (pathkey: string, status: CourseStatus) => void;
}

export const Courses = (props: ICoursesProps) => {
  return (
    <Grid container spacing={2} justifyContent="space-between">
      {props.pathways?.map((pathway) => (
        <CourseItem
          key={pathway.pathkey}
          pathway={pathway}
          statusLoad={props.statusLoad}
        />
      ))}
    </Grid>
  );
};
